// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-document {
    background: #e2eaff;
    padding: 20px;
    border-radius: 8px;
    max-width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    overflow: hidden;
    transition: 'height 0.3s ease'
  }
  
  .document-details {
    font-family: "Roboto", sans-serif;
    color: #333;
    padding: 0 15px;
  }
  
  .data-container-document {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    gap: 10%;
    margin-top: 20px;
  }

  .document-row {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
  }
    
  .label {
    font-weight: bold;
    margin-right: 5px;
  }

  .toggle-text-button {
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    font-weight: bold;
    font-size: 12px;
    padding: 0;
}

.toggle-text-button:hover {
    text-decoration: underline;
}

#content {
  text-align: justify;

}

@media (max-width: 610px) {
  .data-container-document {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .data-document {
    max-width: 80%; 
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/DataDocument.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;EACF;;EAEA;IACE,iCAAiC;IACjC,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;AAEF","sourcesContent":[".data-document {\n    background: #e2eaff;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 400px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-size: 12px;\n    overflow: hidden;\n    transition: 'height 0.3s ease'\n  }\n  \n  .document-details {\n    font-family: \"Roboto\", sans-serif;\n    color: #333;\n    padding: 0 15px;\n  }\n  \n  .data-container-document {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n    gap: 10%;\n    margin-top: 20px;\n  }\n\n  .document-row {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n  }\n    \n  .label {\n    font-weight: bold;\n    margin-right: 5px;\n  }\n\n  .toggle-text-button {\n    background: none;\n    border: none;\n    color: #888;\n    cursor: pointer;\n    font-weight: bold;\n    font-size: 12px;\n    padding: 0;\n}\n\n.toggle-text-button:hover {\n    text-decoration: underline;\n}\n\n#content {\n  text-align: justify;\n\n}\n\n@media (max-width: 610px) {\n  .data-container-document {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .data-document {\n    max-width: 80%; \n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
